import { render, staticRenderFns } from "./FileByTypeLoader.vue?vue&type=template&id=3cf3d572&scoped=true"
import script from "./FileByTypeLoader.vue?vue&type=script&lang=js"
export * from "./FileByTypeLoader.vue?vue&type=script&lang=js"
import style0 from "./FileByTypeLoader.vue?vue&type=style&index=0&id=3cf3d572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3d572",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Inputs/FileByTypeLoader.vue
// module id = 1576
// module chunks = 31